export class AbstractLayout {
    /**
     * Constructs an instance of AbstractLayout with the given container and options.
     * @param {HTMLElement} container - The container element where the layout will be applied.
     * @param {ResolvedOptions} options - The resolved options to apply to the layout.
     */
    constructor(container, options) {
        this.root = globalThis.document.querySelectorAll(options.root);
        this.lightColorMode = options.lightColorMode;
        this.darkColorMode = options.darkColorMode;
        this.lightLabel = options.lightLabel;
        this.darkLabel = options.darkLabel;
        this.style = options.style;
        container.innerHTML = "";
        this.createControl(container);
    }
    /**
     * Updated DOM to current state.
     * - Launch the control state update
     * - Sets the color scheme of all root elements in the layout based on the given boolean.
     * @param {boolean} isLight - A boolean indicating whether to set light mode (`true`) or dark mode (`false`).
     */
    setState(isLight) {
        this.updateControlState(isLight);
        this.root.forEach((el) => {
            el.dataset[AbstractLayout.BS_ATTRIBUTE] = isLight ? this.lightColorMode : this.darkColorMode;
        });
    }
}
AbstractLayout.BS_ATTRIBUTE = "bsTheme";
